import React from 'react';

function nftstaking() {
	return (
		<div class="col-md-10 nftstaking">
			<div class="greeting">
				<img src={`${process.env.PUBLIC_URL}/images/panel2.png`} />
				<img src={`${process.env.PUBLIC_URL}/images/gdmobile.png`} />
			</div>
			<div class="row">
				<div class="col-md-6">
				<h3>NFT Mining</h3>
					<div class="inner">
						<h3>NFT Pool Total Staked</h3>
					 <div class="row">
						<div class="col-md-4 col-xs-6">
							<div class="silver">
							<span>1</span>
							<span>Level - Silver</span>
							<span>0</span>
						    </div>
						</div>
						<div class="col-md-4 col-xs-6">
							<div class="gold">
							<span>2</span>
							<span>Level - Gold</span>
							<span>0</span>
						    </div>
						</div>
						<div class="col-md-4 col-xs-6">
							<div class="diamond">
							<span>3</span>
							<span>Level - Diamond</span>
							<span>0</span>
						    </div>
						</div>
					 </div>
					</div>
				</div>
				<div class="col-md-6">
					<h3>&nbsp;</h3>
					<div class="inner">
						<h3>My Staked</h3>
					 <div class="row">
						<div class="col-md-4 col-xs-6">
							<div class="silver">
							<span>1</span>
							<span>Level - Silver</span>
							<span>0</span>
						    </div>
						</div>
						<div class="col-md-4 col-xs-6">
							<div class="gold">
							<span>2</span>
							<span>Level - Gold</span>
							<span>0</span>
						    </div>
						</div>
						<div class="col-md-4 col-xs-6">
							<div class="diamond">
							<span>3</span>
							<span>Level - Diamond</span>
							<span>0</span>
						    </div>
						</div>
					 </div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<div class="inner">
						<h3>The total House issued by the genesis Pool</h3>
						<p class="pool">0.00</p>
						<img src={`${process.env.PUBLIC_URL}/images/line2.png`} />
						<p class="red">House Mining has ended, Please go to the PLUS mining pool</p>
					</div>
				</div>
				<div class="col-md-6">
					<div class="inner">
						<h3>House Mining Rewards</h3>
						<p class="pool">0.00<a class="yellow harvest floatRight" href="#">Harvest</a></p>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
				  <div class="inner">
					<p>Position Weight: 1</p>
					<img class="plussign" src={`${process.env.PUBLIC_URL}/images/plussign.png`} />
					<a href="#" class="unlocked">Unlocked</a>
					<a href="#" class="yellow stake">Stake</a>
				  </div>
				</div>
				<div class="col-md-3">
				  <div class="inner">
					<h4>&nbsp;</h4>
					<img class="locked" src={`${process.env.PUBLIC_URL}/images/locked.png`} />
					<a href="#" class="unlocked">locked</a>
					<a href="#" class="yellow stake">unlocked</a>
				  </div>
				</div>
				<div class="col-md-3">
				  <div class="inner">
					<h4>&nbsp;</h4>
					<img class="locked" src={`${process.env.PUBLIC_URL}/images/locked.png`} />
					<a href="#" class="unlocked">locked</a>
					<a href="#" class="yellow stake">unlocked</a>
				  </div>
				</div>
				<div class="col-md-3">
				  <div class="inner">
					<h4>&nbsp;</h4>
					<img class="locked" src={`${process.env.PUBLIC_URL}/images/locked.png`} />
					<a href="#" class="unlocked">locked</a>
					<a href="#" class="yellow stake">unlocked</a>
				  </div>
				</div>
			</div>
		</div>
	);
}

export default nftstaking;
			